import * as React from "react"
export const ImageIcon = (props) => (
  <svg
    width={58}
    height={58}
    viewBox='0 0 58 58'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <g opacity={0.5}>
      <path
        d='M54.3173 6.44434H3.68259C1.64891 6.44434 0 8.09314 0 10.1268V47.873C0 49.9065 1.64891 51.5553 3.68259 51.5553H54.3173C56.3511 51.5553 58 49.9065 58 47.8728V10.1268C58 8.09314 56.3512 6.44434 54.3173 6.44434ZM54.3173 10.1268V36.909L47.0599 30.3108C45.9691 29.3193 44.2917 29.3589 43.2495 30.402L35.9045 37.7458L21.4223 20.4471C20.3276 19.1398 18.3224 19.1269 17.2113 20.4186L3.68259 36.1412V10.1268H54.3173ZM38.6667 19.7935C38.6667 16.9966 40.9331 14.73 43.73 14.73C46.527 14.73 48.7935 16.9966 48.7935 19.7935C48.7935 22.5904 46.5271 24.8569 43.73 24.8569C40.9332 24.857 38.6667 22.5904 38.6667 19.7935Z'
        fill='#A7A6CE'
      />
    </g>
  </svg>
)
